import {
  BlockTypeSelect,
  BoldItalicUnderlineToggles,
  CreateLink,
  headingsPlugin,
  linkDialogPlugin,
  linkPlugin,
  listsPlugin,
  ListsToggle,
  markdownShortcutPlugin,
  MDXEditor,
  quotePlugin,
  thematicBreakPlugin,
  toolbarPlugin,
  UndoRedo,
} from '@mdxeditor/editor';

import { cx } from '@libs/classnames';

import '@mdxeditor/editor/style.css';
import '@mdxeditor/editor/style.css';
import styles from './MdInput.module.css';

export type Props = {
  className?: string;
  value?: string;
  onChange?: (value?: string) => void;
  disabled?: boolean;
};

export function MdInput({ className, value, onChange, disabled }: Props) {
  return (
    <MDXEditor
      plugins={[
        toolbarPlugin({
          toolbarClassName: 'my-classname',
          toolbarContents: () => (
            <>
              <UndoRedo />
              <BoldItalicUnderlineToggles />
              <BlockTypeSelect />
              <ListsToggle />
              <CreateLink />
            </>
          ),
        }),
        headingsPlugin(),
        listsPlugin(),
        quotePlugin(),
        thematicBreakPlugin(),
        markdownShortcutPlugin(),
        linkPlugin(),
        linkDialogPlugin(),
      ]}
      className={cx(styles.formattedTextEditor, className, {
        [styles.disabled]: disabled,
      })}
      markdown={value || ''}
      onChange={disabled ? undefined : onChange}
      // TODO disabled does not exists??
    />
  );
}
